module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('header', {
    staticClass: "gheader -white"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("戻る")])])]), (_vm.callbackflg) ? _c('div', {
    staticClass: "container proposals-reply bg03"
  }, [_c('div', {
    staticClass: "row bg04"
  }, [_c('div', {
    staticClass: "proposals-reply__post -detail"
  }, [_vm._m(0), _c('div', {
    staticClass: "proposals-reply__post__body"
  }, [_c('p', {
    staticClass: "proposals-reply__post__body__info"
  }, [_c('span', {
    staticClass: "proposals-reply__post__body__name",
    attrs: {
      "href": ""
    }
  }, [_vm._v(_vm._s(_vm.proposeDetail.attributes['reject-reason']))])]), _c('div', {
    staticClass: "txt-box"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.content(_vm.proposeDetail.attributes['reject-reason-content']))
    }
  })])])]), _c('div', {
    staticClass: "inner bg05"
  }, [_c('div', {
    staticClass: "inner bg04"
  }, [_c('div', {
    staticClass: "user-outline mb15",
    on: {
      "click": function($event) {
        _vm.goProfileDetail(_vm.proposeDetail.attributes['user-id'])
      }
    }
  }, [(_vm.profileImagePath) ? _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.profileImagePath + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  })]) : _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_profile.png")
    }
  })]), _c('div', {
    staticClass: "user-outline__body"
  }, [_c('p', {
    staticClass: "user-outline__body__role"
  }, [_vm._v(_vm._s(_vm.proposeDetail.attributes['shop-name']) + " " + _vm._s(_vm.proposeDetail.attributes['user-type-name']))]), _c('h3', {
    staticClass: "user-outline__body__name"
  }, [_vm._v(_vm._s(_vm.proposeDetail.attributes['user-name'] + ' ' + _vm.proposeDetail.attributes['user-firstname']))])])]), (_vm.joint1User || _vm.joint2User) ? _c('div', {
    staticClass: "user-post-detail__body__others"
  }, [_c('p', {
    staticClass: "fz12 bold brown mb10"
  }, [_vm._v("一緒に提案している人")]), (_vm.joint1User) ? _c('div', {
    staticClass: "user-outline",
    on: {
      "click": function($event) {
        _vm.goProfileDetail(_vm.joint1User.id)
      }
    }
  }, [(_vm.joint1User.attributes['profile-image-path']) ? _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.joint1User.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  })]) : _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_profile.png")
    }
  })]), _c('div', {
    staticClass: "user-outline__body"
  }, [_c('p', {
    staticClass: "user-outline__body__role fz11"
  }, [_vm._v(_vm._s(_vm.joint1User.attributes['shop-name']) + " " + _vm._s(_vm.joint1User.attributes['user-type-name']))]), _c('h3', {
    staticClass: "user-outline__body__name fz16"
  }, [_vm._v(_vm._s(_vm.joint1User.attributes['user-name'] + ' ' + _vm.joint1User.attributes['user-firstname']))])])]) : _vm._e(), (_vm.joint2User) ? _c('div', {
    staticClass: "user-outline",
    on: {
      "click": function($event) {
        _vm.goProfileDetail(_vm.joint2User.id)
      }
    }
  }, [(_vm.joint2User.attributes['profile-image-path']) ? _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.joint2User.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  })]) : _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_profile.png")
    }
  })]), _c('div', {
    staticClass: "user-outline__body"
  }, [_c('p', {
    staticClass: "user-outline__body__role fz11"
  }, [_vm._v(_vm._s(_vm.joint2User.attributes['shop-name']) + " " + _vm._s(_vm.joint2User.attributes['user-type-name']))]), _c('h3', {
    staticClass: "user-outline__body__name fz16"
  }, [_vm._v(_vm._s(_vm.joint2User.attributes['user-name'] + ' ' + _vm.joint2User.attributes['user-firstname']))])])]) : _vm._e()]) : _vm._e(), _c('p', {
    staticClass: "user-post-detail__body__time fz12 brown"
  }, [_vm._v(_vm._s(_vm.proposeDetail.attributes['contribution-at-format']))]), _c('h3', {
    staticClass: "user-post-detail__body__title fz16 bold brown",
    staticStyle: {
      "word-break": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content(_vm.proposeDetail.attributes['propose-title']))
    }
  }), _c('div', {
    staticClass: "user-post-detail__body__contents"
  }, [_c('p', {
    staticStyle: {
      "word-break": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content(_vm.proposeDetail.attributes['propose-content']))
    }
  }), (_vm.proposeDetail.attributes['propose-1-image-path']) ? _c('img', {
    attrs: {
      "src": _vm.proposeDetail.attributes['propose-1-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  }) : _vm._e(), (_vm.proposeDetail.attributes['propose-2-image-path']) ? _c('img', {
    attrs: {
      "src": _vm.proposeDetail.attributes['propose-2-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  }) : _vm._e(), (_vm.proposeDetail.attributes['propose-3-image-path']) ? _c('img', {
    attrs: {
      "src": _vm.proposeDetail.attributes['propose-3-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  }) : _vm._e()])])]), _c('div', {
    staticClass: "proposals-reply__post -no-arrow"
  }, [_vm._m(1), _c('div', {
    staticClass: "proposals-reply__post__body"
  }, [_vm._m(2), _c('div', {
    staticClass: "proposals-reply__post__body__btns mb5"
  }, [_c('button', {
    staticClass: "proposals-reply__post__body__btn -modify",
    on: {
      "click": function($event) {
        _vm.goProposeEdit(_vm.proposeDetail.id)
      }
    }
  }, [_vm._m(3)]), _c('button', {
    staticClass: "proposals-reply__post__body__btn -delete",
    on: {
      "click": function($event) {
        _vm.goProposeDelete(_vm.proposeDetail.id)
      }
    }
  }, [_vm._m(4)])])])])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "proposeDeletedModalButton",
      "type": "button",
      "data-backdrop": "static",
      "data-toggle": "modal",
      "data-target": "#proposeDeletedModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "help-modal",
    attrs: {
      "id": "proposeDeletedModal"
    }
  }, [_c('div', {
    staticClass: "help-modal__body bg03"
  }, [_c('h4', {
    staticClass: "heading_01 fz18 mb25"
  }, [_vm._v("削除しました！")]), _c('button', {
    staticClass: "btn02 -reply",
    on: {
      "click": function($event) {
        _vm.onModalClose()
      }
    }
  }, [_c('span', [_vm._v("お返事一覧へ")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "proposals-reply__post__thumb"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_tairanyan.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "proposals-reply__post__thumb"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_tairanyan.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "proposals-reply__post__body__info -pr20"
  }, [_c('span', {
    staticClass: "proposals-reply__post__body__name",
    attrs: {
      "href": ""
    }
  }, [_vm._v("素敵な提案、ありがとうだニャン！"), _c('br'), _vm._v("いつでもまた投稿してねだニャン！"), _c('br'), _vm._v("再投稿もお待ちしてるニャン！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("編集して"), _c('br'), _vm._v("再確認依頼")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("提案を"), _c('br'), _vm._v("削除する")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21e09f00!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/propose-rejected-detail.pug
// module id = 1382
// module chunks = 1